import { reducerConstants } from "../../../constants/reducer-constant";
import { INITIAL_STATE as carServiceHistoryInfoReducerInitialState, HANDLERS as carServiceHistoryInfoReducerHandler } from "../../../components/desktop/car-service-history-info/reducer";
import { INITIAL_STATE as gaSourceReducerInitialState, HANDLERS as gaSourceReducerHandler } from "../../../components/shared/ga-source/reducers";

export default {
    [reducerConstants.CAR_SERVICE_HISTORY_INFO]: { state: carServiceHistoryInfoReducerInitialState, handler: carServiceHistoryInfoReducerHandler},
    [reducerConstants.GA_SOURCE]: { state: gaSourceReducerInitialState, handler: gaSourceReducerHandler}
};
